import {
    AntennesApi,
    AntennesApiApiAntennesGetCollectionRequest,
    Configuration,
} from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import {
    ApiCollectionResponse,
    FetchCollectionData,
    FetchItemDataType,
    SliceFactory,
} from '@europrocurement/l2d-redux-utils';
import { isEmpty } from 'lodash';
import {
    type Mutable,
    type UtilisateursConfigurationParameters,
    type AntennesUtilisateurApiObject,
} from '../types';
import { ANTENNES_SLICE_NAME, UTILISATEUR_REDUCER_NAME } from '../constants';

export type Antennes = AntennesUtilisateurApiObject;

// function declared for the slice Factory
const mapperServices = function (antennes: Antennes) {
    return {
        ...antennes,
    } as Antennes;
};

/**
 * Function that fetch the collection of poles and store it into the global state Redux
 * @param configuration API configuration parameters
 * @returns the response of API request (get collection/get by id)
 */
export function createAntennesSlice(configuration: UtilisateursConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new AntennesApi(conf);

    /**
     * Send request on get antennas collection in the API and returns the collection
     * @param page current page (1 by default)
     * @param itemsPerPage number max of items in one page (default: 20)
     * @returns the antennas collection (array of antennas objects)
     */
    const fetchAntennaCollection: FetchCollectionData<Antennes> = ({
        pagination: { page, itemsPerPage },
        xIdSociete,
        filters,
        orders,
    }) => {
        const requestParams: Mutable<AntennesApiApiAntennesGetCollectionRequest> = {
            xIdSociete,
            page: page + 1,
            itemsPerPage,
            isDeleted: false,
        };

        // Request with filter isDeleted=true
        if (filters.isDeleted) {
            requestParams.isDeleted = filters.isDeleted as boolean;
        }

        // Request with filter isDeleted=false
        if (filters.isDeleted === false) {
            requestParams.isDeleted = filters.isDeleted as boolean;
        }

        // Order ASC/DESC on libelle and idAntenne only
        if (orders && orders !== null) {
            orders.forEach((order) => {
                if (!isEmpty(order.field) && !isEmpty(order.value)) {
                    switch (order.field) {
                        case 'idAntenne':
                            requestParams.orderIdAntenne = order.value;
                            break;
                        case 'libelle':
                            requestParams.orderLibelle = order.value;
                            break;
                        default:
                    }
                }
            });
        }

        return api
            .apiAntennesGetCollection(requestParams)
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<Antennes>>;
    };

    /**
     * Send request on get antenna by id endpoint and returns the antenna item
     * @param idItem
     * @param xIdSociete
     * @returns the antenna item
     */
    const fetchAntennaItem: FetchItemDataType<Antennes> = ({ idItem, xIdSociete }) =>
        api
            .apiAntennesIdAntenneGet({ idAntenne: String(idItem), xIdSociete })
            .then((res) => res.data) as Promise<Antennes>;

    // Use the utilisateur reducer for the constant because it depends to Utilisateur API
    const { slice: antennesSlice, dataSourcesThunks: antennesDataSourcesThunks } =
        SliceFactory.createSlice<AntennesUtilisateurApiObject, Antennes>(
            ANTENNES_SLICE_NAME,
            UTILISATEUR_REDUCER_NAME,
            [],
            fetchAntennaCollection,
            fetchAntennaItem,
            mapperServices,
            {},
        );
    return { antennesSlice, antennesDataSourcesThunks };
}
